import { StatusBar } from "expo-status-bar";
import { Text, View } from "react-native";

import "./styles";

export default function App() {
    return (
        <View className="flex-1 items-center justify-center bg-white">
            <Text className="text-[#3366cc] text-3xl font-bold">
                TurboPanel
            </Text>
            <Text className="text-green-900 text-xl">Coming Soon!</Text>
            <StatusBar style="auto" />
        </View>
    );
}